// @flow
import { makeGetRequest } from '../utils'

import type { ResponseAPI } from '../types/api'
import type { Country } from '../types/countries'

export const getChannelCountries = (domain: string, serviceSpec: string): Promise<ResponseAPI<Country>> =>
  makeGetRequest(`${domain}/client/api/servicespec/${serviceSpec}/tv/countries?cards`)
